import React from 'react'
import PropTypes from 'prop-types'
import ReactCodeInput from 'react-code-input'
import styles from './PinCodeField.scss'
import ErrorText from '../../ErrorText/ErrorText'

export default function PinCodeInput({ onChange, id, ...rest }) {
  const onValueChange = value => {
    onChange({ target: { id, value } })
  }
  return (
    <div>
      <ReactCodeInput
        autoFocus={true}
        type="text"
        pattern="\d*"
        isValid={rest.error && 'false'}
        onChange={onValueChange}
        id={id}
        className={styles.Input}
        {...rest}
      />
      {rest.error && <ErrorText>{rest.error}</ErrorText>}
    </div>
  )
}

PinCodeInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/Form/PinCodeField/PinCodeField.js